import { get, orderBy, without, includes } from 'lodash';

import APIClient from '../../common/services/APIClient';
import { permissionsLabels, permissions } from '../../common/constants/permissions';

export const rolesRequest = () => ({
  type: 'ROLES_REQUEST',
});

export const clearRoles = () => ({
  type: 'CLEAR_ROLES',
});

export const rolesRequestSuccess = (data) => ({
  type: 'ROLES_REQUEST_SUCCESS',
  data,
});

export const rolesRequestError = (error) => ({
  type: 'ROLES_REQUEST_ERROR',
  error,
});

export const permissionsRequest = () => ({
  type: 'PERMISSIONS_REQUEST',
});

export const permissionsRequestSuccess = (data) => ({
  type: 'PERMISSIONS_REQUEST_SUCCESS',
  data,
});

export const permissionsRequestError = (error) => ({
  type: 'PERMISSIONS_REQUEST_ERROR',
  error,
});

export const createRoleRequest = () => ({
  type: 'CREATE_ROLE_REQUEST',
});

export const createRoleRequestSuccess = (role) => ({
  type: 'CREATE_ROLE_REQUEST_SUCCESS',
  role,
});

export const createRoleRequestError = (error) => ({
  type: 'CREATE_ROLE_REQUEST_ERROR',
  error,
});

export const editRoleRequest = () => ({
  type: 'EDIT_ROLE_REQUEST',
});

export const editRoleRequestSuccess = (role) => ({
  type: 'EDIT_ROLE_REQUEST_SUCCESS',
  role,
});

export const editRoleRequestError = (error) => ({
  type: 'EDIT_ROLE_REQUEST_ERROR',
  error,
});

export const hideRoleSnackbar = () => ({
  type: 'HIDE_ROLES_SNACKBAR',
});

export const fetchRoles =
  (filter = {}) =>
  async (dispatch) => {
    dispatch(clearRoles());
    dispatch(rolesRequest());

    try {
      const { data } = await APIClient.post('/users/roles/list', { filter_by: filter });

      dispatch(rolesRequestSuccess(orderBy(data, 'name')));
    } catch (error) {
      dispatch(rolesRequestError(error.message));
    }
  };

export const fetchPermissions = (userPermissions) => (dispatch) => {
  dispatch(permissionsRequest());

  APIClient.get('/users/permissions')
    .then(({ data }) => {
      const fullAccessPermission = {
        value: permissions.FULL_ACCESS,
        label: permissionsLabels[permissions.FULL_ACCESS],
      };

      const withoutFullAccess = without(data, permissions.FULL_ACCESS);
      const withoutSupervisorAccess = without(withoutFullAccess, permissions.SUPERVISOR);
      const availablePermissions = includes(userPermissions, permissions.FULL_ACCESS) ? withoutFullAccess : withoutSupervisorAccess;

      const limitedPermissions = availablePermissions.map((value) => ({
        value,
        label: permissionsLabels[value],
      }));

      const orderedPermissions = orderBy(limitedPermissions, 'label');

      if (includes(data, permissions.FULL_ACCESS)) {
        orderedPermissions.unshift(fullAccessPermission);
      }

      dispatch(permissionsRequestSuccess(orderedPermissions));
    })
    .catch(({ message }) => {
      dispatch(permissionsRequestError(message));
    });
};

export const createRole = (role, navigate) => (dispatch) => {
  dispatch(createRoleRequest());

  APIClient.post('/users/roles', role)
    .then(({ data }) => {
      dispatch(createRoleRequestSuccess(data));
      dispatch(navigate(`/admin/access-levels/${data.uuid}/edit`, { replace: true }));
    })
    .catch(({ response }) => {
      if (response) {
        const errorCode = get(response, 'data.errors[0].code');
        const errorMessage = errorCode === 105 ? 'Access level name must be unique.' : 'Something went wrong.';

        dispatch(createRoleRequestError(errorMessage));
      }
    });
};

export const editRole = (roleId, role) => (dispatch) => {
  dispatch(editRoleRequest());

  APIClient.put(`/users/roles/${roleId}`, role)
    .then(({ data }) => {
      dispatch(editRoleRequestSuccess(data));
    })
    .catch(({ message }) => {
      dispatch(editRoleRequestError(message));
    });
};
